<template>
  <section>
    <PageTitle guest>
      <Logo />
    </PageTitle>
    <PageTitle>{{ title }}</PageTitle>
    <PageContent>
      <Container>
        <div class="page-error">
          <h2 class="error-title">{{ lead }}</h2>
          <p class="error-message">
            <slot></slot>
          </p>
          <p class="error-link" v-if="topLink">
            <router-link :to="$wcRouter.path({ name: 'index' })">
              トップページへ戻る
            </router-link>
          </p>
        </div>
      </Container>
    </PageContent>
  </section>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    lead: {
      type: String,
      required: true
    },
    topLink: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    businessId() {
      return this.$store.state.app.businessId
    }
  }
}
</script>
